module.exports = {"440982001":"河西街道","440982002":"东山街道","440982003":"下郭街道","440982004":"南盛街道","440982005":"石湾街道","440982100":"长岐镇","440982101":"同庆镇","440982102":"杨梅镇","440982103":"良光镇","440982104":"笪桥镇","440982106":"丽岗镇","440982107":"新安镇","440982108":"官桥镇","440982110":"林尘镇","440982112":"合江镇","440982113":"那务镇","440982114":"播扬镇","440982115":"宝圩镇","440982116":"平定镇","440982117":"文楼镇","440982118":"江湖镇","440982120":"中垌镇","440982400":"鉴江开发区","440982401":"新时代农场","440982402":"新华农场","440982403":"和平农场","440982404":"红阳农场","440982405":"红峰农场","440982406":"建设农场","440982407":"石滩农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440982.json
// module id = 1835
// module chunks = 0